import {
  Component,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  ChangeDetectionStrategy,
  ElementRef,
  Renderer2,
  OnChanges,
} from '@angular/core'

@Component({
  selector: `plan-page-picker`,
  styles: [`
    .inputs > button {
      touch-actions: manipulation;
    }
    .pieces-input {
      max-width: 80px;
      font-size: 30px;
      font-weight: bold;
      text-align: center;
      border-radius: 4px;
    }
    .pieces-input::-webkit-outer-spin-button,
    .pieces-input::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }
  `],
  template: `
  <div class="mobile">
    <ng-template [ngIf]="type === 'numberOfPosts'">
      <div class="picker-wrapper">
        <div class="picker-background">
          <div class="text-center">
            <i class="fas fa-chevron-up text-primary cursor-pointer" (click)="onNativeChange(_value+1, $event)"></i>
          </div>
          <div>
            <input
              class="pieces-input"
              [ngModel]="_value"
              (ngModelChange)="onNativeChange($event)"
            />
          </div>
          <div class="text-center">
            <i class="fas fa-chevron-down text-primary cursor-pointer" (click)="onNativeChange(_value-1, $event)"></i>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template [ngIf]="type === 'words'">
      <div class="picker-wrapper">
        <div class="picker-background">
          <div class="inputs">
            <button class="btn btn-secondary decrementor" (click)="onNativeChange(decrementWords(_value), $event)"><i class="fas fa-minus"></i></button>
            <span class="value">{{_value?.toLocaleString()}}</span>
            <button class="btn btn-secondary incrementor" (click)="onNativeChange(incrementWords(_value), $event)"><i class="fas fa-plus"></i></button>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlanPagePicker implements OnChanges {
  @Input() type: 'numberOfPosts' | 'words';
  @Input() invalid: boolean = false;
  @Input() value: number
  @Output() private valueChange: EventEmitter<number> = new EventEmitter<number>();

  _value: number = null;

  constructor(
    private _elementRef: ElementRef,
    private _renderer: Renderer2
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.value) {
      this._value = this.cleaned(this.value)
      this.ensureValidUi(this._value)
    }
  }

  onNativeChange(newValue: number, event: Event = null): void {
    if (event) {
      event.stopPropagation()
      event.preventDefault()
    }
    this._value = this.cleaned(newValue)
    this.ensureValidUi(this._value)
    this.valueChange.emit(this._value)
  }

  ensureValidUi(value: number): void {
    if (this.type !== 'numberOfPosts') return

    const inputEl = this._elementRef.nativeElement.querySelector('input.pieces-input')
    if (!inputEl) return

    this._renderer.setProperty(inputEl, 'value', value)
  }

  cleaned(value: number): number {
    value = Number(value) || 1
    if (this.type === 'numberOfPosts') {
      if (value < 1)
        return 1
      else if (value >= 999)
        return 999
      else
        return Math.floor(value)
    }

    else {
      return value
    }
  }

  decrementWords(words: number): number {
    if (words <= 1000) {
      return words <= 300 ? 300 : words - 50
    } else {
      return words - 100
    }
  }

  incrementWords(words: number): number {
    if (words < 1000) {
      return words + 50
    } else {
      return words >= 3000 ? 3000 : words + 100
    }
  }
}
